<template>
  <div class="admin_bg">
    <Header :user="user" :token="token" :txt="'回到首页'" @to-logout="toLogout" @to-reg="toReg" @to-record="toRecord"></Header>
    <div class="zhicheng_menu">
      <div class="wrap w1200">
        <div class="col_1 menu_r">
          <router-link :to="'/continueEdu/home'" active-class="focus">首页</router-link>
          <router-link :to="'/continueEdu/courseList'" active-class="focus">课程学习</router-link>
          <router-link :to="'/continueEdu/planList'" active-class="focus">培训计划</router-link>
          <router-link :to="'/continueEdu/enrollList'" active-class="focus">报名信息</router-link>
          <router-link :to="'/continueEdu/trainList'" active-class="focus">培训信息</router-link>
          <router-link :to="'/continueEdu/newsList'" active-class="focus">新闻咨询</router-link>
          <router-link :to="'/continueEdu/taskList'" active-class="focus" v-if="token">任务中心</router-link>
        </div>
        <!--div class="col_2 w200">
          <input name="" type="button" class="search_bt" /><input name="" class="search_put" type="text" placeholder="输入关键字搜索" />
        </div-->
      </div>
    </div>
    <div class="wrap w1200" style="height: 50px; line-height: 50px;">
      首页 - 管理企业 - {{currentPath}}
    </div>
    <div class="wrap w1200" style="position:relative">
      <div class="left_menu_icon" @click="switchMenu($event)"></div>
      <div class="col_1 w222 left_con" v-if="menuStatus">
        <Accordion :model="rmenus" @route-changed="routeChanged"></Accordion>
      </div>
      <div class="w978 w_bg col_2" id="org_right_container">
        <div class="loadingtxt">
          <router-view></router-view>
        </div>
        <div class="clear"></div>
      </div>
    </div>
    <div class="clear"></div>
  </div>
</template>
<script>
  import Header from '@/components/continueEdu/header/header.vue'
  import Accordion from '@/components/common/accordion/index.vue'
  import utils from '@/utils'
  import { getCookie } from '@/store/cookies.js'
  import { mapState, mapActions, mapGetters } from 'vuex'
  export default {
    components: { Header, Accordion },
    data () {
      return {
        currentPath: this.$route.meta.title,
        fuser: {},
        rmenus: [],
        menuStatus: true
      }
    },
    created () {
    },
    mounted () {
      this.getMenus({isShow: '1'})
    },
    watch: {
      user (val) {
        if (val) {
          this.fuser = val
        }
      },
      getCurrentMenus (val) { // 确保已获取到菜单的数据
        function iteration (data) {
          for (var j = 0; j < data.length; j++) {
            data[j].active = true
            if (data[j].children != undefined && data[j].children.length > 0) {
              iteration(data[j].children)
            }
          }
        }
        this.rmenus = val
        this.rmenus.forEach((o) => {
          if (`/continueEdu${o.href}` == this.$route.path) {
            o.active = true // 当前菜单点亮
            if (o.children) {
              o.opened = true
              // iteration(o.children) // 子孙也要点亮
            }
          }
        })
      }
    },
    computed: {
      ...mapState('auth', ['user', 'token']),
      ...mapGetters('orgmenus', ['getCurrentMenus'])
    },
    methods: {
      ...mapActions('auth', {
        logout: 'logout'
      }),
      ...mapActions('orgmenus', {
        getMenus: 'getMenus'
      }),
      toLogout () {
        this.logout()
      },
      toReg () {
        this.$router.push('/byl/orgreg')
      },
      toRecord () {
        this.$router.push('/continueEdu/index')
      },
      routeChanged (route) { // 从路由表里获得名称
        this.currentPath = route.name
        if (utils.isAbsolutePath(route.href)) {
          this.$router.push({path: '/continueEdu/org/externals', query: {url: route.href + getCookie('token')}})
        }
      },
      switchMenu ($event) {
        this.menuStatus = !this.menuStatus;
        this.menuStatus === true ? this.getMenus({isShow: '1'}) : '';
        if ($($event.target).hasClass("left_menu_icon")) {
          $($event.target).removeClass("left_menu_icon").addClass("right_menu_icon");
          $("#org_right_container").removeClass("w978").addClass("w1200");
          $(".zy_right").removeClass("w797").addClass("w1004");
          $(".structure_org_stretch").removeClass("w705").addClass("w925");
          $(".withInputs_stretch").removeClass("w365").addClass("w585");
          $("#org_right_container").css("box-shadow", "-6px 0px 15px #e6e6e6")
        } else if ($($event.target).hasClass("right_menu_icon")) {
          $($event.target).removeClass("right_menu_icon").addClass("left_menu_icon");
          $("#org_right_container").removeClass("w1200").addClass("w978");
          $(".zy_right").removeClass("w1004").addClass("w797");
          $(".structure_org_stretch").removeClass("w925").addClass("w705");
          $(".withInputs_stretch").removeClass("w585").addClass("w365");
        }
      }
    }
  }
</script>
<style lang="scss">
  @import "../../../assets/scss/platform";
</style>



// WEBPACK FOOTER //
// src/page/continueEdu/org/index.vue